import {loadYaml} from '@/script/common';

export interface GimmickBase {
  name: string;
  image: string;
}

export interface GimmickHook {
  status: number;
  nextStatus: number;
  targetList: string[];
}

export interface GimmickEventChangeImage {
  type: 'image';
  target: string;
  image: string;
}

export interface GimmickEventChangeUrl {
  type: 'page';
  urlTarget: string;
}

export interface GimmickAction {
  status: number;
  eventList: Array<GimmickEventChangeImage | GimmickEventChangeUrl>;
}

export interface GimmickInfo {
  baseList: GimmickBase[];
  hookList: GimmickHook[];
  actionList: GimmickAction[];
}

export default class GimmickManager {
  // シングルトン
  public static get INSTANCE(): GimmickManager {
    if (!GimmickManager._INSTANCE) {
      GimmickManager._INSTANCE = new GimmickManager();
    }
    return GimmickManager._INSTANCE;
  }
  private static _INSTANCE: GimmickManager;

  // public gimmickInfoList: GimmickInfo[] = [];
  public gimmickInfo: GimmickInfo | null = null;
  public status: number = 0;

  // コンストラクタの隠蔽
  private constructor() {}

  public async init() {
    this.status = 0;
    this.gimmickInfo = await loadYaml<GimmickInfo>('config/gimmick.yaml')!;
    this.gimmickInfo.baseList.forEach((gimmickBase) => {
      gimmickBase.image = `${process.env.VUE_APP_IMAGE_BASE_URL}${gimmickBase.image}`;
    });
    this.gimmickInfo.actionList.forEach((gimmickAction) => {
      gimmickAction.eventList.forEach((event) => {
        if (event.type === 'image') {
          event.image = `${process.env.VUE_APP_IMAGE_BASE_URL}${event.image}`;
        }
      });
    });
  }
}
